import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useTranslation } from "react-i18next";

export type OrderRequestApproveAssociatedBookingDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirmWithoutBookingApproval: () => void;
  onConfirmWithBookingApproval: () => void;
};

export function OrderRequestApproveAssociatedBookingDialog({
  open,
  onClose,
  onConfirmWithoutBookingApproval,
  onConfirmWithBookingApproval
}: Readonly<OrderRequestApproveAssociatedBookingDialogProps>) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>{t("_orderRequest_approveAssociatedBookingTitle")}</DialogTitle>
      <DialogContent>{t("_orderRequest_approveAssociatedBookingDesc")}</DialogContent>
      <DialogActions>
        <Button
          data-testid="approve-associated-booking-no-btn"
          color="secondary"
          onClick={onConfirmWithoutBookingApproval}
        >
          {t("No")}
        </Button>
        <Button
          data-testid="approve-associated-booking-yes-btn"
          onClick={onConfirmWithBookingApproval}
        >
          {t("Yes")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
